import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "member-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "flex flex-row gap-1 items-center text-6 font-bold uppercase mb-4" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import { memberGet } from "@/common/api/rest/member";
import {
	accountShowByMember,
	accountStatus,
} from "@/common/api/rest/account/account";

import {
	affiliateList,
	affiliatePatch,
	affiliateCreate,
	affiliateDelete,
} from "@/common/api/rest/account/affiliate";

import {
	baseInput,
	baseSelect,
	baseTextarea,
	baseConfirm,
	baseModal,
	baseTable,
	breadcrumbSimple,
	tabMenu,
} from "@/common/components";

import FormAffiliate from "@/components/forms/form-affiliate.vue";

type TabActiveType = "edit" | "cv";


export default /*@__PURE__*/_defineComponent({
  __name: 'affiliate',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const member = ref<any>(null);
const account = ref<any>(null);
const selected = ref<any>(null);
const payload = ref<any>(null);

const tableData = ref<any[]>([]);
const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalDel = ref(false);
const isEdit = ref(false);

const memberId = computed(() => route.params.member as string);

const tableHeader = [
	{ key: "name", label: "Nome" },
	{ key: "email", label: "Email" },
	{ key: "type", label: "Tipo" },
	{ key: "status", label: "Status" },
];

const breadcrumbList = computed(() => [
	{
		key: "members",
		label: t("common.labels.members"),
		url: "/members",
	},
	{
		key: "member",
		label: member.value?.name || t("common.labels.member"),
	},
	{
		key: "edit",
		label: t("common.labels.edit"),
	},
]);

const tabList = computed(() => [
	{
		key: "edit",
		label: t("common.labels.member").toUpperCase(),
	},
	{
		key: "account",
		label: t("common.labels.account").toUpperCase(),
	},
	{
		key: "affiliate",
		label: "AFILIADOS",
	},
]);

const statusEnum = computed(() => ({
	ACTIVE: "ATIVO",
	INACTIVE: "INATIVO",
	CANCELED: "CANCELADO",
	RESTRICTED: "RESTRITO",
	PAST_DUE: "EM ATRASO",
}));

async function fetchData() {
	await memberGet(memberId.value)
		.then((response) => {
			const { success, data, message } = response;

			if (success) {
				member.value = data;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});

	await accountShowByMember(memberId.value)
		.then((response) => {
			const { success, data, message } = response;

			if (success) {
				account.value = data;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function fecthAffiliates() {
	affiliateList({
		account_id: account.value.account_id,
		page: page.value,
		limit: limit.value,
		search: search.value,
	})
		.then((response) => {
			const { success, data, message } = response;

			if (success) {
				tableData.value = data.list;
				page.value = data.infos.page;
				pages.value = data.infos.pages;
				total.value = data.infos.total;
				searched.value = data.infos.count;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function changePage(value: number) {
	page.value = value;
	fecthAffiliates();
}

function searchItem(value: string) {
	search.value = value;
	page.value = 0;

	fecthAffiliates();
}

function openModal(data?: any) {
	if (data) {
		selected.value = data;
		isEdit.value = true;
	}

	showModalAdd.value = true;
}

function closeModal() {
	showModalAdd.value = false;
}

function updateAffiliate() {
	if (!selected.value) return;

	affiliatePatch(selected.value.affiliate_id, {
		type: payload.value.type,
		status: payload.value.status,
	})
		.then((response) => {
			const { success, message } = response;

			if (success) {
				closeModal();
				fecthAffiliates();
				toast({ message: message, type: "success" });
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function createAffiliate() {
	if (!payload.value) return;

	store.commit("SET_LOADING", true);

	affiliateCreate({
		...payload.value,
		account_id: account.value.account_id,
	})
		.then((response) => {
			const { success, message } = response;

			if (success) {
				closeModal();
				fecthAffiliates();
				toast({ message: message, type: "success" });
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function submitPayload() {
	if (isEdit.value) {
		updateAffiliate();
	} else {
		createAffiliate();
	}
}

function removeAffiliate(value: any) {
	selected.value = value;
	showModalDel.value = true;
}

function removeAffiliateCancel() {
	selected.value = null;
	showModalDel.value = false;
}

function removeAffiliateConfirm() {
	if (!selected.value) return;

	store.commit("SET_LOADING", true);

	affiliateDelete(selected.value.affiliate_id)
		.then((response) => {
			const { success, message } = response;

			fecthAffiliates();
			removeAffiliateCancel();
			toast({ message: message, type: success ? "success" : "error" });
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function selectTab(tab: TabActiveType) {
	router.push(`/members/${memberId.value}/${tab}`);
}

onMounted(async () => {
	await fetchData();

	fecthAffiliates();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_unref(tabMenu), {
        tabs: tabList.value,
        tooltip: false,
        active: "affiliate",
        width: "fit-content",
        "padding-inline": "1.5rem",
        "onSelect:tab": selectTab
      }, {
        content: _withCtx(() => [
          _createVNode(_unref(baseTable), {
            header: tableHeader,
            data: tableData.value,
            limit: limit.value,
            page: page.value,
            pages: pages.value,
            total: total.value,
            searched: searched.value,
            options: true,
            add: true,
            del: true,
            edit: true,
            "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
            onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
            "onBtn:add": _cache[2] || (_cache[2] = ($event: any) => (openModal())),
            "onBtn:edit": _cache[3] || (_cache[3] = ($event: any) => (openModal($event))),
            "onBtn:del": _cache[4] || (_cache[4] = ($event: any) => (removeAffiliate($event)))
          }, {
            status: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(statusEnum.value[data.status]), 1)
            ]),
            name: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.name), 1)
            ]),
            _: 1
          }, 8, ["data", "limit", "page", "pages", "total", "searched"])
        ]),
        _: 1
      }, 8, ["tabs"])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[6] || (_cache[6] = ($event: any) => (closeModal())),
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (submitPayload()))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, _toDisplayString(isEdit.value ? "EDITAR" : "ADICIONAR") + " AFFILIADO ", 1)
      ]),
      content: _withCtx(() => [
        _createVNode(FormAffiliate, {
          data: selected.value,
          onUpdateData: _cache[5] || (_cache[5] = ($event: any) => (payload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: "Remover Affiliado",
      message: 
				_unref(t)('common.texts.remove_message', {
					concat: selected.value?.name,
				})
			,
      onCancel: removeAffiliateCancel,
      onConfirm: removeAffiliateConfirm
    }, null, 8, ["show", "message"])
  ]))
}
}

})